export default __webpack_public_path__ + "static/media/kereta-icon.b03f3876.svg";